<mat-form-field class="color-selector-form resized">
    <div class="current-color" [style.background-color]="selectedOption"><sup class="required-star">*</sup></div>
    <mat-select (selectionChange)="onColorChange($event)" [(value)]="selectedOption" panelClass="colors-panel">
        <mat-option *ngFor="let color of colorList" [value]="color">
            <div class="color-circle" [style.background-color]="color"></div>
        </mat-option>
    </mat-select>
</mat-form-field>